import useMessage from "../useMessage";

type DigiohQuizCompleteMessage = {
  type: "DIGIOH_QUIZ_COMPLETE";
  data: { ids: string[] };
};

export type DigiohQuizCompleteMessageEvent =
  MessageEvent<DigiohQuizCompleteMessage>;

const digiohQuizCompleteMessageMatch = {
  data: { type: "DIGIOH_QUIZ_COMPLETE", data: { ids: [] } },
};

const useDigiohQuizCompleteMessage = (
  onEvent: (event: DigiohQuizCompleteMessageEvent) => void,
) => {
  useMessage<DigiohQuizCompleteMessage>(onEvent, {
    match: digiohQuizCompleteMessageMatch,
  });
};

export default useDigiohQuizCompleteMessage;
